<template>
  <div class="page-weakspot">
    <el-breadcrumb separator="/" class="weakspot-breadcrumb">
      <el-breadcrumb-item to="test-center">
        <span class="weakspot-color">测评中心</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="weakspot-color" @click="$router.go(-1)">
          {{ className }}</span
        >
      </el-breadcrumb-item>
      <el-breadcrumb-item>创建知识点巩固练习</el-breadcrumb-item>
    </el-breadcrumb>
    <header>
      <span />
      <p>创建知识点巩固练习</p>
    </header>
    <div v-if="!showTransfer && !showImg">
      <section>
        <!-- 知识点名称 -->
        <div class="set-hw-item">
          <p class="item-name"><span class="emphasis">*</span> 练习名称:</p>
          <div class="input-item">
            <input
              id="hwName"
              type="text"
              v-model="hwName"
              maxlength="30"
              max="30"
              placeholder="请填写练习名称"
              class="input-param"
              @change="changeHwName"
            />
          </div>
          <div>{{ this.hwName.length }}/30</div>
        </div>
        <!-- 知识点数量 -->
        <div class="set-weakspot-item">
          <p class="item-name">练习知识点(共{{ tagNames.length }}个):</p>
          <div class="weakspot-item-content">
            <el-tag
              v-for="(tag, index) in tagNames"
              :key="index"
              type="info"
              size="small"
            >
              {{ tag }}
            </el-tag>
          </div>
        </div>
        <!-- 知识点题量 -->
        <div class="set-weakspot-count">
          <p class="item-name weakspot-name">
            <span class="emphasis">*</span> 每个知识点练习题量:
          </p>
          <div>
            <div class="control-number">
              <div
                class="btn"
                @click="decrease"
                :class="{ disabled: questionNum <= 1 }"
              >
                <i class="el-icon-minus"></i>
              </div>
              <input
                type="text"
                ref="input"
                max="5"
                min="1"
                class="question-num-input"
                placeholder="请填写"
                v-model="questionNum"
              />
              <div
                class="btn right"
                @click="add"
                :class="{ disabled: questionNum >= 5 }"
              >
                <i class="el-icon-plus" />
              </div>
              <div class="item-label">每个知识点限1~5题</div>
            </div>
            <p class="control-content">
              共<span>{{ tagNames.length }}</span> 个知识点，每个知识点推题<span
                >{{ questionNum }}</span
              >题， 总推送题目<span>{{ this.totalNum }}</span> 题，预计用时<span
                >{{ estimateTime }}</span
              >分钟
            </p>
          </div>
        </div>
        <!-- 出题难度 -->
        <div class="set-weakspot-difficult">
          <p class="item-name weakspot-name">
            <span class="emphasis">*</span> 出题难度:
          </p>
          <div
            v-for="(item, index) in difficultList"
            :key="index"
            :class="[activeNum === index ? 'active' : '', 'difficult-name']"
            @click="changeDifficult(index)"
          >
            {{ item.name }}
          </div>
        </div>
      </section>
      <footer>
        <p class="error-info emphasis" v-if="error1">
          作业名称信息不规范,请重新输入
        </p>
        <div class="button-list">
          <button @click="goBack">取消</button>
          <button class="create" @click="goCreate">创建</button>
        </div>
      </footer>
    </div>

    <Transfer v-if="showTransfer" :answer-url="answerUrl" @goBack="goBack" />
    <div class="setting-question" v-if="showImg">
      <img src="~@/views/pt/images/setting_question.png" alt="" />
      <p class="setting-question__title">系统正在出题中...</p>
    </div>
  </div>
</template>
<script>
import { createKnowledgeOrWrong, getShortUrl } from '@/api/pt';
import storeCreator from '@/utils/store-creator';
import Transfer from './components/transfer.vue';

export default {
  name: 'CreateWeakSpot',
  components: { Transfer },
  data() {
    const { className, subjectName } = this.$route.query;
    const store = storeCreator.create('pt');
    return {
      selectedList: JSON.parse(store.get('selectedList')),
      subjectName,
      className,
      createUrlParamsList: {},
      answerUrl: [], // 短链接的集合
      tagNames: [],
      tagCodes: [],
      showImg: false,
      showTransfer: false,
      error1: false,
      activeNum: 1,
      questionNum: 3, // 知识点出题数量 默认3道
      hwName: '', // 课程名称
      totalNum: 0, // 出题总数
      estimateTime: 0, // 预计用时
      difficultNum: 2, // 出题难度默认为中等
      difficultList: [{ name: '偏简单', id: 1 }, { name: '中等', id: 2 }, { name: '困难', id: 3 }],
    };
  },
  methods: {
    // 知识点名称的操作
    changeHwName() {
      this.hwName = document.getElementById('hwName').value;
      if (this.hwName !== '' || this.hwName.length <= 30) {
        this.error1 = false;
      }
    },
    // 出题数量的操作
    add() {
      if (this.questionNum >= 5) {
        return;
      }
      this.questionNum = this.questionNum * 1 + 1;
      this.setTotalNum(this.tagNames.length, this.questionNum);
    },
    decrease() {
      if (this.questionNum <= 1) {
        return;
      }
      this.questionNum -= 1;
      this.setTotalNum(this.tagNames.length, this.questionNum);
    },
    setTotalNum(tagNum, qNum) {
      this.totalNum = tagNum * qNum;
      this.estimateTime = Math.ceil(tagNum * qNum * 1.5);
      return this.totalNum;
    },
    // 出题难度的操作
    changeDifficult(index) {
      this.activeNum = index;
      this.difficultNum = this.difficultList[index].id;
    },
    // 底部按钮操作
    goBack() {
      this.$router.go(-1);
    },
    goCreate() {
      if (this.hwName === '' || this.hwName.length > 30) {
        this.error1 = true;
        return;
      }
      this.showImg = true;
      this.createKnowledge();
    },
    // 创建知识点练习
    createKnowledge() {
      const {
        subjectId, classId, testId, testName, testType,
      } = this.$route.query;
      const params = {
        test_id: testId,
        test_name: testName,
        class_id: classId,
        subject_id: subjectId,
        exercise_name: this.hwName,
        tag_code: JSON.stringify(this.tagCodes),
        question_number: this.totalNum,
        question_difficulty: this.difficultNum,
        type: Number(testType) === 3 ? 3 : 1,
      };
      createKnowledgeOrWrong(params).then((res) => {
        if (res.code === 200) {
          this.createUrlParamsList = res.data;
          setTimeout(() => {
            this.getShortUrl();
          }, 1000);
        }
      });
    },
    // 获取短链接
    getShortUrl() {
      if (!Object.keys(this.createUrlParamsList).length) {
        return;
      }
      const params = { long_url: `${window.location.origin}/pt/export-test?serialNum=${this.createUrlParamsList.serial_num}&teacherId=${this.createUrlParamsList.teacher_id}&showAnswer=0` };
      const answerParams = { long_url: `${window.location.origin}/pt/export-test?serialNum=${this.createUrlParamsList.serial_num}&teacherId=${this.createUrlParamsList.teacher_id}&showAnswer=1` };
      const getContectUrl = getShortUrl(params);
      const getAnswerUrl = getShortUrl(answerParams);
      Promise.all([getContectUrl, getAnswerUrl]).then((result) => {
        if (result[0].code === 200 && result[1].code === 200) {
          this.showImg = false;
          this.showTransfer = true;
          this.answerUrl = result;
        }
      }).catch((error) => {
        console.log(error);
      });
    },
  },
  created() {
    this.selectedList.forEach((item) => {
      this.tagNames.push(item.tag_name);
      this.tagCodes.push(item.tag_code);
      this.setTotalNum(this.tagNames.length, this.questionNum);
    });
  },
  mounted() {
    const myDate = new Date();
    let tMonth = myDate.getMonth() + 1;
    let tDay = myDate.getDate();
    tMonth = tMonth < 10 ? `0${tMonth}` : tMonth;
    tDay = tDay < 10 ? `0${tDay}` : tDay;
    this.hwName = `${tMonth}${tDay}${this.className}${this.subjectName}巩固练习`;
  },
};
</script>
<style lang="scss" scoped>
.page-weakspot {
  background-color: #ffffff;
  height: 100%;
  font-family: 'PingFangSC-Regular', 'PingFang SC';
}
.weakspot-breadcrumb {
  padding: 20px;
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
}
.weakspot-color {
  color: #1989fa;
  cursor: pointer;
}
.emphasis {
  color: red;
}
.item-name {
  font-size: 16px;
  margin-right: 14px;
  color: #000000;
}
.weakspot-name {
  height: 40px;
  line-height: 40px;
}
header {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 20px;
  span {
    display: inline-block;
    width: 3px;
    height: 16px;
    background: #1890ff;
    border-radius: 3px;
  }
  p {
    font-size: 18px;
    font-weight: 800;
    color: #000000;
    margin-left: 8px;
    &::after {
      content: "";
      position: absolute;
      left: 10px;
      bottom: 2px;
      width: 164px;
      height: 13px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 7px;
    }
  }
}
.set-hw-item {
  display: flex;
  align-items: center;
  margin-left: 100px;
  margin-top: 37px;
  font-size: 12px;
  .input-item {
    margin-right: 12px;
    .input-param {
      width: 298px;
      height: 40px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d8dce6;
      outline: none;
      text-indent: 8px;
    }
  }
}
.set-weakspot-item {
  display: flex;
  margin-left: 45px;
  margin-top: 24px;
  .weakspot-item-content {
    width: 793px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding: 5px 12px 13px 0;
  }
  .weakspot-item-content /deep/ .el-tag {
    color: #5a5e66;
    background: #f0f2f5;
    margin-left: 12px;
    margin-top: 8px;
  }
}
.set-weakspot-count {
  margin-top: 24px;
  margin-left: 20px;
  font-size: 12px;
  display: flex;
  .control-number {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .btn {
      width: 40px;
      height: 40px;
      background: #f5f7fa;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #d8dce6;
      text-align: center;
      line-height: 40px;
      &.disabled {
        opacity: 0.5;
      }
      &.right {
        border-radius: 0px 4px 4px 0px;
      }
    }
    .item-label {
      margin-left: 16px;
      font-size: 14px;
    }
    .question-num-input {
      width: 73px;
      height: 40px;
      outline: none;
      padding: 0;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      text-align: center;
    }
  }
  .control-content {
    font-size: 14px;
    span {
      color: #E6A23C;
    }
  }
}
.set-weakspot-difficult {
  margin-left: 100px;
  margin-top: 36px;
  display: flex;
  align-items: center;
  font-size: 12px;
  .difficult-name {
    margin-right: 12px;
    width: 90px;
    height: 40px;
    // background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    line-height: 40px;
    text-align: center;
    &.active {
      color: #1989fa;
      border: 1px solid #1989fa;
    }
  }
}
footer {
  margin-top: 74px;
  margin-bottom: 83px;
  background: #ffffff;
  font-size: 12px;
  .error-info {
    margin-bottom: 12px;
    margin-left: 194px;
  }
  .button-list {
    margin-left: 194px;
    button {
      width: 120px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
    }
    .create {
      background: #1989fa;
      color: #ffffff;
      margin-left: 24px;
    }
    &::after {
      content: "";
      display: block;
      height: 73px;
      background: #ffffff;
    }
  }
}
.setting-question {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 92px;
  &__title {
    margin-top: 32px;
  }
}
</style>
